__turbopack_context__.v({
  "contentOverlay": "BSnyYG_contentOverlay",
  "heading": "BSnyYG_heading",
  "sectionWrapper": "BSnyYG_sectionWrapper",
  "watchButton": "BSnyYG_watchButton",
});
